import Modals from "@/utils/Modals";

export const ModalsArr = [
  //Modals.ACCIDENTAL_DAMAGE_MODAL,
  Modals.COVERED_MODAL,
  Modals.FILE_CLAIM_MODAL,
  Modals.MY_POLICY_MODAL,
  Modals.FAQ_MODAL,
  Modals.PARTNERSHIPS_MODAL,
  Modals.CONTACT_MODAL,
];
